/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';


class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="109.03" height="78.21" viewBox="0 0 109.03 78.21" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  <path d="M77.76,37.75A1.26,1.26,0,0,1,79,38.87V55.25a1.25,1.25,0,0,1-1.25,1.25,1.26,1.26,0,0,1-1.24-1.13V39A1.25,1.25,0,0,1,77.76,37.75Z" transform="translate(-23.25 -37.75)" fill="#fcb61c"/><path d="M115.48,53.81a1.25,1.25,0,0,1,1.77,0,1.23,1.23,0,0,1,.09,1.66l-.09.1L105.76,67a1.24,1.24,0,0,1-1.85-1.66l.09-.11Z" transform="translate(-23.25 -37.75)" fill="#fcb61c"/><g>
      <path d="M97.41,42.54a1.25,1.25,0,0,1,2.35.84l0,.12-6.23,15a1.25,1.25,0,0,1-2.36-.83l.05-.12Z" transform="translate(-23.25 -37.75)" fill="#fcb61c"/>
      <path d="M128.29,71.55a1.25,1.25,0,0,1,1.05,2.27l-.12.05L114.15,80a1.25,1.25,0,0,1-1.05-2.26l.11-.06Z" transform="translate(-23.25 -37.75)" fill="#fcb61c"/>
      <path d="M25.88,71.61a1.25,1.25,0,0,1,1.51-.72l.12,0,15,6.27a1.25,1.25,0,0,1,.67,1.64,1.24,1.24,0,0,1-1.51.71l-.12,0-15-6.27A1.24,1.24,0,0,1,25.88,71.61Z" transform="translate(-23.25 -37.75)" fill="#fcb61c"/>
      <path d="M56.55,41.84a1.25,1.25,0,0,1,1.58.56l0,.12,6.2,15a1.25,1.25,0,0,1-2.26,1.07l0-.12-6.2-15A1.25,1.25,0,0,1,56.55,41.84Z" transform="translate(-23.25 -37.75)" fill="#fcb61c"/>
    </g><path d="M38.26,53.79a1.24,1.24,0,0,1,1.67-.09l.1.09L51.52,65.28a1.25,1.25,0,0,1-1.67,1.85l-.1-.09L38.26,55.56A1.27,1.27,0,0,1,38.26,53.79Z" transform="translate(-23.25 -37.75)" fill="#fcb61c"/><g>
      <path d="M77.76,64.91a29.51,29.51,0,0,1,29.51,29.5,1.25,1.25,0,0,1-2.5,0,27,27,0,0,0-54,0,1.25,1.25,0,0,1-2.5,0A29.5,29.5,0,0,1,77.76,64.91Z" transform="translate(-23.25 -37.75)" fill="#fcb61c"/>
      <path d="M131,93.16a1.25,1.25,0,0,1,.13,2.5H24.5a1.25,1.25,0,0,1-.13-2.49H131Z" transform="translate(-23.25 -37.75)" fill="#0e497b"/>
      <path d="M113.27,103.31a1.25,1.25,0,0,1,.13,2.49H42.25a1.25,1.25,0,0,1-.12-2.49h71.14Z" transform="translate(-23.25 -37.75)" fill="#0e497b"/>
      <path d="M100.59,113.46a1.25,1.25,0,0,1,.13,2.49H54.94a1.25,1.25,0,0,1-.13-2.5h45.78Z" transform="translate(-23.25 -37.75)" fill="#0e497b"/>
    </g>
</svg>

    );
  }
}

Icon.displayName = 'SunsetOverWaterHorizonIcon';

export default Icon;
